import type { Query } from "@tanstack/react-query";

import { toast } from "@/shared/hooks/use-toast";
import { errorToast } from "@/shared/lib/apiErrors";

/** 全局兜底 toast 在没有码映射时用的语境标题。 */
export const GLOBAL_QUERY_ERROR_TITLE = "数据加载失败";

/**
 * audit-0713 C1a:查询错误零静默的底线兜底 —— 全库大量列表页不写 isError,接口挂时
 * 界面伪装成空态。全局 QueryCache onError 保证用户至少能感知失败;页面自己渲染了
 * 错误态(QueryErrorBanner/QueryState)的,用 meta.suppressGlobalErrorToast 退订防双报。
 *
 * 0926 修复波第六批 R:此前直接画 `error.message`,后端拼进来的内部地址 / 异常原文
 * (如 `I/O error on POST request for "http://gscq-ai:8000/…"`)原样怼给用户。
 * 改走公共错误层 errorToast:标题按错误码,默认开启的 `hideRawDetail` 把内部原文挡在描述之外(只留码 + 排查号)。
 */
export function onGlobalQueryError(
  error: unknown,
  query: Pick<Query<unknown, unknown, unknown>, "meta">
): void {
  if (query.meta?.suppressGlobalErrorToast) return;
  toast(errorToast(error, { fallbackTitle: GLOBAL_QUERY_ERROR_TITLE }));
}
